import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "maximized", "headerProps", "toggleButtonProps", "messagesProps", "promptProps", "headerComponent", "promptComponent", "toggleButtonComponent", "classNames", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cx } from "../../lib/index.js";
import { createChatHeaderComponent } from "./ChatHeader.js";
import { createChatMessagesComponent } from "./ChatMessages.js";
import { createChatPromptComponent } from "./ChatPrompt.js";
import { createChatToggleButtonComponent } from "./ChatToggleButton.js";
export function createChatComponent(_ref) {
  var createElement = _ref.createElement,
    Fragment = _ref.Fragment;
  var ChatToggleButton = createChatToggleButtonComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  var ChatHeader = createChatHeaderComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  var ChatMessages = createChatMessagesComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  var ChatPrompt = createChatPromptComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  return function Chat(_ref2) {
    var open = _ref2.open,
      _ref2$maximized = _ref2.maximized,
      maximized = _ref2$maximized === void 0 ? false : _ref2$maximized,
      headerProps = _ref2.headerProps,
      toggleButtonProps = _ref2.toggleButtonProps,
      messagesProps = _ref2.messagesProps,
      _ref2$promptProps = _ref2.promptProps,
      promptProps = _ref2$promptProps === void 0 ? {} : _ref2$promptProps,
      HeaderComponent = _ref2.headerComponent,
      PromptComponent = _ref2.promptComponent,
      ToggleButtonComponent = _ref2.toggleButtonComponent,
      _ref2$classNames = _ref2.classNames,
      classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, _excluded);
    return createElement("div", _extends({}, props, {
      className: cx('ais-Chat', maximized && 'ais-Chat--maximized', classNames.root, className)
    }), createElement("div", {
      className: cx('ais-Chat-container', open && 'ais-Chat-container--open', maximized && 'ais-Chat-container--maximized', classNames.container)
    }, createElement(HeaderComponent || ChatHeader, _objectSpread(_objectSpread({}, headerProps), {}, {
      classNames: classNames.header,
      maximized: maximized
    })), createElement(ChatMessages, _extends({}, messagesProps, {
      classNames: classNames.messages,
      messageClassNames: classNames.message
    })), createElement(PromptComponent || ChatPrompt, _objectSpread(_objectSpread({}, promptProps), {}, {
      classNames: classNames.prompt
    }))), createElement("div", {
      className: "ais-Chat-toggleButtonWrapper"
    }, createElement(ToggleButtonComponent || ChatToggleButton, _objectSpread(_objectSpread({}, toggleButtonProps), {}, {
      classNames: classNames.toggleButton,
      onClick: function onClick() {
        var _toggleButtonProps$on;
        (_toggleButtonProps$on = toggleButtonProps.onClick) === null || _toggleButtonProps$on === void 0 ? void 0 : _toggleButtonProps$on.call(toggleButtonProps);
        if (!open) {
          var _promptProps$promptRe, _promptProps$promptRe2;
          (_promptProps$promptRe = promptProps.promptRef) === null || _promptProps$promptRe === void 0 ? void 0 : (_promptProps$promptRe2 = _promptProps$promptRe.current) === null || _promptProps$promptRe2 === void 0 ? void 0 : _promptProps$promptRe2.focus();
        }
      }
    }))));
  };
}